import React from "react";
import PropTypes from "prop-types";
import numeral from "numeral";

const UtilitySpending = ({ data, numberOfCountries, selectedCountryName }) => {
  const {
    utility_capex_spending,
    country_rank,
    growth_forecast,
    country_id,
    current_year
  } = data;

  const renderGrowthForecast = val => val ? `${val}%` : "-";

  return (
    <div className="utility-spending">
      <div className="title">
        <a
          href={`/data-hub/forecasts?utility_dashboard=1&utility_country_codes=${country_id && country_id.toUpperCase()}`}
          className="country-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          Utility spending
        </a>
      </div>
      <div className="utility-spending-data">
        <div className="item">
          <span className="bold">
            ${utility_capex_spending
            ?
            numeral(utility_capex_spending).divide(1000).format("0.000")
            :
            "-"
            }
          </span>
          &nbsp;billion utility capital expenditure <span className="year">({current_year})</span>
        </div>
        {selectedCountryName !== "World" && country_rank &&
          <div className="item"><span className="bold">{country_rank}/{numberOfCountries}</span> world rank for capital expenditure</div>
        }
        <div className="item">
          <span className="bold">{renderGrowthForecast(growth_forecast)}</span> annual growth over the next 5 years
        </div>
      </div>
    </div>
  );
};

UtilitySpending.propTypes = {
  data: PropTypes.shape({}),
  selectedCountryName: PropTypes.string.isRequired,
  numberOfCountries: PropTypes.number.isRequired,
  current_year: PropTypes.string,
};

export default UtilitySpending;
